"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _OTCKJ4OKcjs = require('../__chunks/OTCKJ4OK.cjs');


var _5MLKOK3Fcjs = require('../__chunks/5MLKOK3F.cjs');


var _XIM2KQSLcjs = require('../__chunks/XIM2KQSL.cjs');
require('../__chunks/7JL3CCPE.cjs');
require('../__chunks/6P52IAFY.cjs');
require('../__chunks/PFM4PJSG.cjs');
require('../__chunks/SARAALGA.cjs');
require('../__chunks/MPIQVHCB.cjs');
require('../__chunks/ITCIC2TC.cjs');
require('../__chunks/MWXEIKZX.cjs');
require('../__chunks/T3QB4FR3.cjs');
require('../__chunks/FH6HQ5JN.cjs');




var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');



var _3BSDKDKDcjs = require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/hovercard/hovercard-disclosure.tsx
var _dom = require('@ariakit/core/utils/dom');
var _events = require('@ariakit/core/utils/events');
var _misc = require('@ariakit/core/utils/misc');
var _store = require('@ariakit/core/utils/store');
var _react = require('react');
var _jsxruntime = require('react/jsx-runtime');
var TagName = "button";
var useHovercardDisclosure = _PTOCUU2Dcjs.createHook.call(void 0, function useHovercardDisclosure2({ store, ...props }) {
  const context = _OTCKJ4OKcjs.useHovercardProviderContext.call(void 0, );
  store = store || context;
  _misc.invariant.call(void 0, 
    store,
    process.env.NODE_ENV !== "production" && "HovercardDisclosure must receive a `store` prop or be wrapped in a HovercardProvider component."
  );
  const [visible, setVisible] = _react.useState.call(void 0, false);
  _react.useEffect.call(void 0, () => {
    if (!visible) return;
    const onBlur = (event) => {
      if (!store) return;
      const nextActiveElement = event.relatedTarget;
      if (nextActiveElement) {
        const {
          anchorElement: anchor,
          popoverElement: popover,
          disclosureElement: disclosure
        } = store.getState();
        if (anchor && _dom.contains.call(void 0, anchor, nextActiveElement)) return;
        if (popover && _dom.contains.call(void 0, popover, nextActiveElement)) return;
        if (disclosure && _dom.contains.call(void 0, disclosure, nextActiveElement)) return;
        if (nextActiveElement.hasAttribute("data-focus-trap")) return;
      }
      setVisible(false);
    };
    return _events.addGlobalEventListener.call(void 0, "focusout", onBlur, true);
  }, [visible, store]);
  _react.useEffect.call(void 0, () => {
    return _store.sync.call(void 0, store, ["anchorElement"], (state) => {
      const anchor = state.anchorElement;
      if (!anchor) return;
      const observer = new MutationObserver(() => {
        if (!anchor.hasAttribute("data-focus-visible")) return;
        setVisible(true);
      });
      observer.observe(anchor, { attributeFilter: ["data-focus-visible"] });
      return () => observer.disconnect();
    });
  }, [store]);
  const onClickProp = props.onClick;
  const onClick = _3BSDKDKDcjs.useEvent.call(void 0, (event) => {
    onClickProp == null ? void 0 : onClickProp(event);
    if (event.defaultPrevented) return;
    store == null ? void 0 : store.setAutoFocusOnShow(true);
  });
  const onFocusProp = props.onFocus;
  const onFocus = _3BSDKDKDcjs.useEvent.call(void 0, (event) => {
    onFocusProp == null ? void 0 : onFocusProp(event);
    if (event.defaultPrevented) return;
    setVisible(true);
  });
  const { style } = _5MLKOK3Fcjs.useVisuallyHidden.call(void 0, );
  if (!visible) {
    props = {
      ...props,
      style: {
        ...style,
        ...props.style
      }
    };
  }
  const children = /* @__PURE__ */ _jsxruntime.jsx.call(void 0, 
    "svg",
    {
      display: "block",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.5,
      viewBox: "0 0 16 16",
      height: "1em",
      width: "1em",
      children: /* @__PURE__ */ _jsxruntime.jsx.call(void 0, "polyline", { points: "4,6 8,10 12,6" })
    }
  );
  props = {
    children,
    ...props,
    ref: _3BSDKDKDcjs.useMergeRefs.call(void 0, store.setDisclosureElement, props.ref),
    onClick,
    onFocus
  };
  props = _XIM2KQSLcjs.useDialogDisclosure.call(void 0, { store, ...props });
  return props;
});
var HovercardDisclosure = _PTOCUU2Dcjs.forwardRef.call(void 0, function HovercardDisclosure2(props) {
  const htmlProps = useHovercardDisclosure(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});



exports.HovercardDisclosure = HovercardDisclosure; exports.useHovercardDisclosure = useHovercardDisclosure;
